import { FC } from "react";

import FlexContainer from "@/components/FlexContainer";
import { SecondaryText } from "@/components/Typography/Styled";

import { StyledFinGroup } from "./Styled";

interface IFinGroups {
    finGroups: string[];
}

export const FinGroups: FC<IFinGroups> = ({ finGroups }) => (
    <FlexContainer
        width="100%"
        gap="12px"
        flexDirection="column"
        alignItems="flex-start"
        justifyContent="flex-start"
        style={{ paddingBottom: 12 }}
    >
        <SecondaryText
            fontSize={14}
            fontWeight="400"
            lineHeight="140%"
            padding="0 0 0 20px"
        >
            Групи фін. обліку:
        </SecondaryText>

        {finGroups.map((group) => (
            <StyledFinGroup key={group}>{group}</StyledFinGroup>
        ))}
    </FlexContainer>
);
